import { t } from "i18next";
import { Trans } from "react-i18next";

export const getColumns = (): any[] => [
  {
    title: t("Description"),
    dataIndex: "sourceType",
    render: (data: string) => {
      return (
        <>
          <div className="text-kds-fg-soft text-[14px] font-normal mb-[4px]">
            <Trans>{data}</Trans>
          </div>
          {/* <Tag variant="filled" className="rounded-full! text-kds-fg-soft leading-[20px] text-[12px]">
            <Trans>Kaloclip</Trans>
          </Tag> */}
        </>
      );
    },
  },
  {
    title: t("Date"),
    dataIndex: "date",
    render: (data: string) => {
      return <span className="text-kds-fg-soft">{data || "--"}</span>;
    },
  },
  {
    title: t("Amount"),
    dataIndex: "creditsChange",
    render: (data: number) => {
      return (
        <span className="text-kds-fg-soft">
          {data > 0 ? "+" : ""}
          {data.toFixed(1)}
        </span>
      );
    },
  },
  {
    title: t("usage_account"),
    dataIndex: "mainAccount",
    render: (data: string) => {
      return <span className="text-kds-fg-soft">{data}</span>;
    },
  },
  {
    title: t("usage_user"),
    dataIndex: "consumerAccount",
    render: (data: any) => {
      return <span className="text-kds-fg-soft">{data || "--"}</span>;
    },
  },
];

export const tabOptions = [
  { label: "All", value: "All" },
  { label: "Kaloclip", value: "Kaloclip" },
  { label: "Kalodata", value: "Kalodata" },
];
